<script lang="ts">
      import LexicalRender from '../lexical/LexicalRender.svelte'

      let { block } = $props()
</script>

<div class="w-full p-4 md:py-8 md:px-24 font-primary">
      <div class="quote-block mx-auto w-full max-w-lg">
            <span class="tick front"></span>
            <LexicalRender root={block.quote?.root ?? null}></LexicalRender>
            <span class="tick rear"></span>
      </div>
      <div class="ml-auto text-sm text-center font-[300]">
            {block.name}
      </div>
</div>

<style lang="postcss">
      @reference "tailwindcss/theme";

      .quote-block {
            @apply italic text-center;
            text-wrap: pretty;
      }

      .quote-block :global(p) {
            display: inline;
            /*text-wrap: pretty;*/
      }
      /*.quote-block > :global(.lexical-output::before),
      .quote-block > :global(.lexical-output::after) {
            background-image: url(/quote.svg);
            content: '';
            background-repeat: no-repeat;
            opacity: 0.4;
            background-size: 70%;
            height: 1em;
            display: inline-block;
            aspect-ratio: 1 / 1;
            background-position: top;
            vertical-align: middle;
            margin-left: 0.1em;
      }*/

      .tick {
            background-image: url(/quote_green.svg);
            content: '';
            background-repeat: no-repeat;
            opacity: 0.7;
            background-size: 100%;
            height: 1em;
            width: 0.5rem;
            display: inline-block;
            aspect-ratio: 1 / 1;
            background-position: top;
            vertical-align: top;
            margin: 0.3rem;
            /*margin-left: 0.1em;*/
      }

      .tick:global(.rear) {
        margin-left: -.1rem;
      }
      .tick:global(.front) {
        transform: scale(-1);
        margin-right: -0.2rem;
        margin-bottom: 0.4rem;
        vertical-align: bottom;
      }
</style>
